import React, { Component } from 'react'
//import PropTypes from 'prop-types'
import Radium from 'radium'
import ReactSVG from 'react-svg'

import TEHelmet from './../../../component/Header/TEHelmet'

import images from './../../../config/images'
import styles from './styles'

class Home extends Component {
	render(){

		const meta = {
			title 		: 'Rebel Analytics | Home',
			description	: 'Think Differently About Performance Marketing',
		}

		return (
			<div style={styles.container}>
				<TEHelmet {...meta}/>
				<div style={styles.header}>
					<h1 style={styles.headerTitle}>BE BETTER INFORMED.<br/>MAKE BETTER DECISIONS.</h1>
					<a href='http://rebel-travel.com/contact-us/' style={styles.headerLink}>Learn More</a>
				</div>
				<div style={styles.whatWeDoContainer}>
					<h2 style={styles.whatWeDoTitle}>What We Do</h2>
					<div style={styles.starWrapper}>
						<ReactSVG
							path={images.star}
							style={styles.star}
						/>
					</div>
					<p style={styles.whatWeDoCopy}>We are a full service Digital Marketing firm that leverages your data to tell your story. REBEL Analytics was designed to help hoteliers around the world increase direct bookings and lower distribution cost by leveraging a property's data to offer the best in-house marketing consulting and innovative technology solutions.</p>
				</div>
				<div style={styles.servicesContainer}>
					<div style={styles.service}>
						<div style={styles.serviceIconWrapper}>
							<ReactSVG
								path={images.seo}
								style={styles.serviceIcon}
							/>
						</div>
						<h4 style={styles.serviceTitle}>Search Engine Optimization</h4>
					</div>
					<div style={styles.service}>
						<div style={styles.serviceIconWrapper}>
							<ReactSVG
								path={images.webDesign}
								style={styles.serviceIcon}
							/>
						</div>
						<h4 style={styles.serviceTitle}>Website Design</h4>
					</div>
					<div style={styles.service}>
						<div style={styles.serviceIconWrapper}>
							<ReactSVG
								path={images.chatbot}
								style={styles.serviceIcon}
							/>
						</div>
						<h4 style={styles.serviceTitle}>Chatbot</h4>
					</div>
					<div style={styles.service}>
						<div style={styles.serviceIconWrapper}>
							<ReactSVG
								path={images.blog}
								style={styles.serviceIcon}
							/>
						</div>
						<h4 style={styles.serviceTitle}>Blog</h4>
					</div>
					<div style={styles.service}>
						<div style={styles.serviceIconWrapper}>
							<ReactSVG
								path={images.googleAnalytics}
								style={styles.serviceIcon}
							/>
						</div>
						<h4 style={styles.serviceTitle}>Google Analytics</h4>
					</div>
					<div style={styles.service}>
						<div style={styles.serviceIconWrapper}>
							<ReactSVG
								path={images.ppc}
								style={styles.serviceIcon}
							/>
						</div>
						<h4 style={styles.serviceTitle}>Pay-Per-Click</h4>
					</div>
					<div style={styles.service}>
						<div style={styles.serviceIconWrapper}>
							<ReactSVG
								path={images.performanceAudits}
								style={styles.serviceIcon}
							/>
						</div>
						<h4 style={styles.serviceTitle}>Performance Audits</h4>
					</div>
				</div>
				<div style={styles.mapContainer}>
					<h2 style={styles.mapTitleMobile}>LET’S GET IN TOUCH</h2>
					<div style={styles.mapWrapper}>
						<ReactSVG
							path={images.map}
							style={styles.map}
						/>
					</div>
					<h2 style={styles.mapTitle}>LET’S<br/>GET<br/>IN<br/>TOUCH</h2>
					<a href='http://rebel-travel.com/contact-us/' style={styles.mapLink} key='connected'>Stay Connected</a>
				</div>
			</div>
		)
	}
}

Home.propTypes = {}

Home.defaultProps = {}

export default Radium(Home)



// WEBPACK FOOTER //
// ./src/pages/Front/Home/Home.js